import React, { useContext, useEffect, useState } from "react";
import { PAGE_STATE } from "../../constants";
import useUsers from "../../hooks/useUsers";
import ProfileContext from "./ProfileContext";
import { useNavigate } from "react-router-dom";
import ContentLoader from "react-content-loader";
const assetsUri = import.meta.env.ASSETS_URI;

const HeaderFollowing = () => {
  const [list, setList] = useState(undefined);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const { querySubscriptions, queryUsers, queryCompanies } = useUsers();
  const { user, isCompany, company, isSubscribed } = useContext(ProfileContext);
  const navigate = useNavigate();

  useEffect(() => {
    if ((isCompany && !company) || (!isCompany && !user)) {
      setPageState(PAGE_STATE.LOADING);
      return;
    }

    fetchData();
  }, [user, company, isCompany, isSubscribed]);

  const fetchData = async () => {
    // TODO: Make scrollable
    const { data: subscriptions } = await querySubscriptions(
      {
        subscribes: isCompany ? company._id : user._id,
        active: true,
        deleted: false,
      },
      null,
      -1,
      { createdBy: 1, active: 1, company: 1 },
      { createdOn: 1 }
    );

    if (subscriptions.length === 0) {
      setPageState(PAGE_STATE.IDLE);
      setList([]);
      return;
    }

    const _userIds = [];
    const _companyIds = [];
    let _users = [];
    let _companies = [];

    for (const { createdBy, company } of subscriptions) {
      if (company) {
        _companyIds.push(company);
        continue;
      }

      _userIds.push(createdBy);
    }

    if (_userIds.length > 0) {
      // * Get avatar and name
      const { data: users } = await queryUsers(
        {
          _id: {
            $in: _userIds,
          },
        },
        null,
        -1,
        {
          _id: 1,
          avatar: 1,
          firstname: 1,
          surname: 1,
          uri: 1,
        }
      );

      _users = users;
    }

    if (_companyIds.length > 0) {
      // * Get avatar and name
      const { data: companies } = await queryCompanies(
        {
          _id: {
            $in: _companyIds,
          },
        },
        null,
        -1,
        {
          _id: 1,
          logo: 1,
          name: 1,
        }
      );

      _companies = companies;
    }

    setList(
      subscriptions
        .map((s) => {
          if (s.company) {
            const _companyMatch = _companies.find((c) => c._id === s.company);

            if (!_companyMatch) return null;

            return {
              _id: _companyMatch._id,
              avatar: _companyMatch.logo,
              name: _companyMatch.name,
              isCompany: true,
            };
          }

          const _userMatch = _users.find((u) => u._id === s.createdBy);

          if (!_userMatch) return null;

          return {
            _id: _userMatch._id,
            avatar: _userMatch.avatar,
            name: `${_userMatch.firstname} ${_userMatch.surname ?? ""}`,
            uri: _userMatch.uri,
            isCompany: false,
          };
        })
        .filter((_) => !!_)
    );
    setPageState(PAGE_STATE.IDLE);
  };

  if (pageState === PAGE_STATE.LOADING || list === undefined) {
    return (
      <div className="profile-content-followers">
        <ContentLoader width={"100%"} height={44}>
          <circle cx="22" cy="22" r="22" />
          <circle cx="86" cy="22" r="22" />
          <circle cx="150" cy="22" r="22" />
        </ContentLoader>
      </div>
    );
  }

  return (
    <div className="profile-content-followers">
      {list.map(({ isCompany, avatar, _id, uri }) => {
        return (
          <img
            key={`follower-${_id}`}
            alt="followers-avatar"
            className="profile-content-followers__item"
            src={`${assetsUri}/${avatar}`}
            onClick={() => {
              if (isCompany) {
                navigate(`/companies/${_id}`);
                return;
              }

              navigate(`/${uri}`);
            }}
            onError={({ target }) => {
              target.src = avatar;
            }}
          />
        );
      })}
    </div>
  );
};

HeaderFollowing.propTypes = {};

export default HeaderFollowing;
